import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from "react";
import s from "./ResponsiveTable.module.scss";

// Preserve existing row actions and expanded editors while providing labels on phones.
export default function ResponsiveTable({ children, className, ...props }) {
  useInterfaceLanguage();
  const elements = React.Children.toArray(children);
  const head = elements.find(
    (child) => React.isValidElement(child) && child.type === "thead",
  );
  const row =
    head &&
    React.Children.toArray(head.props.children).find(
      (child) => React.isValidElement(child) && child.type === "tr",
    );
  const labels = row
    ? React.Children.toArray(row.props.children).map(
        (cell) => cell.props?.children,
      )
    : [];
  const decorate = (nodes) =>
    React.Children.map(nodes, (node) => {
      if (!React.isValidElement(node)) return node;
      if (node.type === "tr") {
        const cells = React.Children.toArray(node.props.children);
        const detail = cells.some((cell) => Number(cell.props?.colSpan) > 1);
        return React.cloneElement(
          node,
          {
            className: `${node.props.className || ""} ${
              detail ? s.detailRow : ""
            }`,
          },
          cells.map((cell, index) =>
            React.isValidElement(cell) && cell.type === "td"
              ? React.cloneElement(cell, {
                  "data-label": detail
                    ? undefined
                    : typeof labels[index] === "string"
                      ? labels[index]
                      : "",
                  key: cell.key || index,
                })
              : cell,
          ),
        );
      }
      if (node.type === "tbody" || node.type === React.Fragment)
        return React.cloneElement(node, {}, decorate(node.props.children));
      return node;
    });
  return (
    <div className={s.wrap}>
      <table {...props} className={`${className || ""} ${s.table}`}>
        {decorate(children)}
      </table>
    </div>
  );
}
